import Nav from "./components/Nav";
import Hero from "./components/Hero";
import ChannelBoard from "./components/ChannelBoard";
import HotBoard from "./components/HotBoard";
import PersonArchive from "./components/PersonArchive";
import FeatureRead from "./components/FeatureRead";
import TimelineBoard from "./components/TimelineBoard";
import TopicWall from "./components/TopicWall";
import CollectionIndex from "./components/CollectionIndex";
import AboutBar from "./components/AboutBar";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 text-foreground-950">
      <Nav />
      <main className="flex-1">
        {/* 01 首屏：文案优先 */}
        <Hero />
        {/* 02 栏目索引：四个深扒方向 */}
        <ChannelBoard />
        {/* 03 本周热议榜 */}
        <HotBoard />
        {/* 04 人物起底档案 */}
        <PersonArchive />
        {/* 05 深扒长文精选 */}
        <FeatureRead />
        {/* 06 内幕时间线 */}
        <TimelineBoard />
        {/* 07 黑历史话题墙 */}
        <TopicWall />
        {/* 08 档案馆合集索引 */}
        <CollectionIndex />
        {/* 09 本站定位说明 */}
        <AboutBar />
      </main>
      <Footer />
    </div>
  );
}